import { render } from "./assessment-panel--level-inactive.vue?vue&type=template&id=2d37302c&scoped=true&ts=true"
import script from "./assessment-panel--level-inactive.vue?vue&type=script&lang=ts"
export * from "./assessment-panel--level-inactive.vue?vue&type=script&lang=ts"

import "./assessment-panel--level-inactive.vue?vue&type=style&index=0&id=2d37302c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d37302c"]])

export default __exports__